"use client";
import { AnimatePresence, motion } from "framer-motion";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import ProfilePage from "./pages/Profile";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Admin from "./pages/admin/Admin";
import ModelCreation from "./pages/admin/ModelCreation";
import ModelListing from "./pages/admin/ModelListing";
import ModelEdit from "./pages/admin/ModelEdit";
import ModelTraining from "./pages/admin/ModelTrain";
import FeedbackListing from "./pages/admin/FeedbackListing";
import ProtectedRoute from "./components/ProtectedRoute";
import KnowledgeBaseListing from "./pages/admin/KnowledgeBaseListing";
import AdminLayout from "./routes/AdminLayout";

// Animated page transitions wrapper
const PageTransition = ({ children }) => {
  return (
    <AnimatePresence mode="wait">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

const App = () => {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      <Routes>
        {/* Public Routes - Outside Protection */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <PageTransition>
                <Dashboard />
              </PageTransition>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/:chatId"
          element={
            <ProtectedRoute>
              <PageTransition>
                <Dashboard />
              </PageTransition>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin-dashboard"
          element={
            <ProtectedRoute forAdmin>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Admin />} />
          <Route path="model-create" element={<ModelCreation />} />
          <Route path="feedback" element={<FeedbackListing />} />
          <Route path="model-edit/:modelId" element={<ModelEdit />} />
          <Route path="model-train" element={<ModelTraining />} />
          <Route path="model-list" element={<ModelListing />} />
          <Route path="knowledgebase-list" element={<KnowledgeBaseListing />} />
        </Route>

        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <PageTransition>
                <ProfilePage />
              </PageTransition>
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile/:chatId"
          element={
            <ProtectedRoute>
              <PageTransition>
                <ProfilePage />
              </PageTransition>
            </ProtectedRoute>
          }
        />
        {/* Redirect any unknown routes to login or landing */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};

export default App;
